import React from 'react';
import { Link } from 'react-router-dom';
import { Music, Heart, MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative bg-black border-t border-white/10">
      {/* Effet de dégradé subtil */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-gray-900/50 to-black"></div>
      
      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
            {/* Logo et description */}
            <div className="lg:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <Music className="h-10 w-10 text-yellow-400" />
                <h3 className="text-2xl font-light text-white">
                  Musique <span className="heading-accent font-semibold">Buchta</span>
                </h3>
              </div>
              <p className="text-white/70 font-light leading-relaxed mb-6 max-w-md">
                Artisan accordeur, restaurateur de pianos et magasin de musique généraliste 
                du Haut-Rhin en Alsace. Une passion familiale au service de l'excellence musicale.
              </p>
              <p className="text-white/50 font-light text-sm">
                Depuis plusieurs générations, nous perpétuons l'art de l'accordage 
                et de la restauration de pianos avec passion et expertise.
              </p>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-6 heading-accent">Nos Services</h4>
              <ul className="space-y-3 text-white/70 font-light">
                <li>Accordage professionnel</li>
                <li>Restauration d'instruments</li>
                <li>Pianos neufs & d'occasion</li>
                <li>Location événementielle</li>
                <li>Instruments du monde</li>
                <li>Conseil personnalisé</li>
              </ul>
            </div>

            {/* Contact rapide */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-6 heading-accent">Contact</h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="h-5 w-5 text-yellow-400 mt-1 flex-shrink-0" />
                  <div className="text-white/70 font-light text-sm">
                    <p>122, rue de l'Île Napoléon</p>
                    <p>68170 RIXHEIM</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-yellow-400 flex-shrink-0" />
                  <a href="tel:+33389542003" className="text-white/70 hover:text-yellow-400 transition-colors font-light text-sm">
                    03.89.54.20.03
                  </a>
                </div>
                
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-yellow-400 flex-shrink-0" />
                  <a href="tel:+33607971604" className="text-white/70 hover:text-yellow-400 transition-colors font-light text-sm">
                    06.07.97.16.04
                  </a>
                </div>
                
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-yellow-400 flex-shrink-0" />
                  <a href="mailto:musique.buchta@gmail.com" className="text-white/70 hover:text-yellow-400 transition-colors font-light text-sm">
                    musique.buchta@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Séparateur */}
          <div className="border-t border-white/10 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
                <p className="text-white/50 font-light text-sm">
                  © 2025 Musique Buchta. Tous droits réservés.
                </p>
                <Link to="/mentions-legales" className="text-white/50 hover:text-yellow-400 transition-colors font-light text-sm">
                  Mentions légales
                </Link>
              </div>
              <div className="flex items-center space-x-2 text-white/50 font-light text-sm">
                <span>Créé avec</span>
                <Heart className="h-4 w-4 text-yellow-400" />
                <span>pour la musique</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;